// Generated from UserWorkoutStats's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'
import type {GrainType} from '../entity/Stats'

export type UserWorkoutStatsCollectionFilterGroups
  = | {
    readonly grain: GrainType | GrainType[]
    readonly user: Iri | Iri[]
    readonly workout?: Iri
    readonly year?: number | number[] | '*'
  }

export const userWorkoutStatsCollectionFilterMapping: FilterDefinitionMapping<UserWorkoutStatsCollectionFilterGroups> = {
  grain: 'grain',
  user: 'user',
  workout: 'workout',
  year: 'year',
}

export type UserWorkoutStatsCollectionSort = never
